import { motion } from 'framer-motion';
import { Wifi, Battery, Cpu, Activity } from 'lucide-react';

export const StatusWidgets = ({ currentTime }) => {
  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      weekday: 'short',
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <>
      {/* Top Status Bar */}
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="absolute top-0 left-0 right-0 z-40"
      >
        <div className="glass-panel border-b border-border/50 px-6 py-3">
          <div className="flex items-center justify-between">
            {/* Left - System Name */}
            <div className="flex items-center gap-3">
              <div className="text-xl font-bold glow-text">ALVIN'S OS</div>
              <div className="h-4 w-px bg-border" />
              <div className="text-xs text-muted-foreground font-mono">v2.0.1</div>
            </div>

            {/* Center - Time */}
            <div className="flex flex-col items-center">
              <div className="text-2xl font-bold font-mono glow-text">
                {formatTime(currentTime)}
              </div>
              <div className="text-xs text-muted-foreground">
                {formatDate(currentTime)}
              </div>
            </div>

            {/* Right - Status Icons */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <Cpu className="w-4 h-4 text-primary" />
                <span className="text-xs text-muted-foreground">45%</span>
              </div>
              <div className="flex items-center gap-2">
                <Activity className="w-4 h-4 text-success" />
                <span className="text-xs text-muted-foreground">ONLINE</span>
              </div>
              <div className="flex items-center gap-2">
                <Wifi className="w-4 h-4 text-primary" />
              </div>
              <div className="flex items-center gap-2">
                <Battery className="w-4 h-4 text-success" />
                <span className="text-xs text-muted-foreground">98%</span>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Data Stream Widget - Top Right */}
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="absolute top-20 right-6 z-30"
      >
        <div className="glass-panel tech-border rounded-xl p-4 w-64">
          <div className="space-y-3">
            <div className="text-xs font-bold text-primary">SYSTEM METRICS</div>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-xs text-muted-foreground">UPTIME</span>
                <span className="text-xs font-mono text-foreground">127:42:18</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-xs text-muted-foreground">MEMORY</span>
                <span className="text-xs font-mono text-foreground">12.4 / 32 GB</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-xs text-muted-foreground">NETWORK</span>
                <span className="text-xs font-mono text-success">850 Mbps</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-xs text-muted-foreground">LATENCY</span>
                <span className="text-xs font-mono text-primary">2ms</span>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Quick Stats - Bottom Left */}
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="absolute bottom-20 left-6 z-30"
      >
        <div className="glass-panel tech-border rounded-xl p-4 w-48">
          <div className="space-y-3">
            <div className="text-xs font-bold text-accent">QUICK ACCESS</div>
            <div className="space-y-2">
              <div className="text-xs text-muted-foreground">Recent: Terminal</div>
              <div className="text-xs text-muted-foreground">Tasks: 8 Active</div>
              <div className="text-xs text-muted-foreground">Alerts: None</div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default StatusWidgets;